import React, { useState, useEffect } from 'react';
import supabase from '../supabase/supabase';

export default function AdminPostForm({ onPostUploaded }) {
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    const { data } = await supabase.from('categories_1715000000').select('*').order('name');
    if (data) setCategories(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!files || files.length === 0 || !categoryId) return setMsg('Files and Category are required');
    setLoading(true);
    setMsg('');

    try {
      let uploadedCount = 0;
      const fileArray = Array.from(files);
      
      for (const file of fileArray) {
        const fileExt = file.name.split('.').pop();
        const fileName = `${Date.now()}_${Math.random()}.${fileExt}`;
        
        const { error: uploadError } = await supabase.storage
          .from('portfolio_images')
          .upload(fileName, file);
        
        if (uploadError) throw uploadError;
        
        const { data: { publicUrl } } = supabase.storage
          .from('portfolio_images')
          .getPublicUrl(fileName);

        const { error: dbError } = await supabase.from('posts_1715000000').insert([{
          category_id: categoryId,
          image_url: publicUrl
        }]);

        if (dbError) throw dbError;
        uploadedCount++;
        setMsg(`Uploading... (${uploadedCount}/${fileArray.length})`);
      }

      setMsg(`Successfully published ${fileArray.length} graphic(s)!`);
      setFiles([]);
      document.getElementById('file-upload').value = '';
      if (onPostUploaded) onPostUploaded();
      
    } catch (error) {
      setMsg(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-8 rounded-3xl shadow-retro border-4 border-retro-brown">
      <h2 className="font-display text-2xl tracking-wider text-retro-brown uppercase mb-6 drop-shadow-[1px_1px_0_#13A09E]">Manual Upload</h2>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-6">
        <div>
          <label className="block text-lg font-bold text-retro-brown mb-2">Category</label>
          <select 
            value={categoryId} 
            onChange={(e) => setCategoryId(e.target.value)}
            className="w-full p-4 border-4 border-retro-brown rounded-xl focus:outline-none focus:ring-4 focus:ring-retro-blue font-bold text-retro-brown bg-white shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] appearance-none cursor-pointer"
            required
          >
            <option value="">Select a category...</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>
        </div>
        
        <div>
          <label className="block text-lg font-bold text-retro-brown mb-2">Graphics</label>
          <div className="relative border-4 border-dashed border-retro-brown/40 rounded-xl p-6 hover:bg-retro-cream transition-colors text-center cursor-pointer">
            <input 
              id="file-upload" 
              type="file" 
              accept="image/*" 
              multiple 
              onChange={(e) => setFiles(e.target.files)}
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              required 
            />
            <p className="font-bold text-retro-brown text-lg">Click or drag files here</p>
            {files.length > 0 && (
              <p className="text-base text-retro-teal mt-2 font-bold bg-white inline-block px-4 py-1 border-2 border-retro-brown rounded-full shadow-retro-sm">{files.length} selected</p>
            )}
          </div>
        </div>

        <button 
          type="submit" 
          disabled={loading} 
          className="w-full bg-retro-teal text-white py-4 rounded-xl font-display text-xl tracking-wider border-4 border-retro-brown shadow-retro hover:shadow-retro-hover hover:-translate-y-1 active:translate-y-1 active:shadow-retro-active transition-all mt-2 disabled:opacity-50"
        >
          {loading ? 'UPLOADING...' : 'PUBLISH NOW'}
        </button>

        {msg && (
          <div className={`text-base font-bold text-center p-4 border-4 border-retro-brown rounded-xl ${msg.toLowerCase().includes('error') ? 'bg-red-100 text-red-700' : 'bg-retro-lime text-retro-brown shadow-retro-sm'}`}>
            {msg}
          </div>
        )}
      </form>
    </div>
  );
}